import { EDIT_TEAM, EDIT_TEAM_FAIL, EDIT_TEAM_SUCCESS } from './actionTypes';

export const editTeam = ({ teamId, teamDetails }) => ({
    type: EDIT_TEAM,
    payload: { teamId, teamDetails }
});

export const editTeamSuccess = team => ({
    type: EDIT_TEAM_SUCCESS,
    payload: team
});

export const editTeamFail = error => ({
    type: EDIT_TEAM_FAIL,
    payload: error
});
